/**
 * Auto generated file using cli command
 * _> cronos front-enum
 * !! DO NOT EDIT THIS FILE MANUALLY !!
 * Manual changes will be overwritten
 */

export enum USER_TYPE {
	None = 0,
	Agency = 1,
	Client = 2,
	TempWorker = 3,
	Armado = 100,
}
